/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import { Button } from "primereact/button";
import React, { useEffect, useReducer, useState } from "react";
import useApiEstaciones from "../../api/catalogos/useApiEstaciones";
import formReducer from "../../shared/forms/formReducer";
import FormHandler from "../../shared/forms/formHandler";
import estacionesValidacionEsquema from "./estacionesValidacionEsquema";
import FieldTextBox from "../../shared/controls/fieldTextBox";
import FieldDropDown from "../../shared/controls/fieldDropDown";
import FieldCheckBox from "../../shared/controls/fieldCheckBox";
import ReadOnlyProvider from "../../shared/forms/ReadOnlyProvider";
import ButtonIcon from "../../shared/controls/ButtonIcon";
import produce from "immer";
import alerts from "../../shared/alerts";
import "./estaciones.css";
import useApiSource from "../../api/source";
import { TabPanel, TabView } from "primereact/tabview";
import { Tooltip } from "primereact/tooltip";
const DetalleEstaciones = ({ estacionId, onSave, close, soloLectura }) => {
    const api = useApiEstaciones();
    const apiSource = useApiSource();
    const defaultEntity = () => ({
        entity: { id: 0, activo: true, clientesIds: [], usuariosIds: [], subClientesIds: [] },
    });
    const [{ entity, errors }, dispatch] = useReducer(formReducer, {}, defaultEntity);
    const [clientes, setClientes] = useState(null);
    const [subClientes, setsubClientes] = useState(null);

    const [activeIndex, setActiveIndex] = useState();

    useEffect(() => {
        async function cargar() {
            dispatch({ type: "update", value: await api.obtener(estacionId) });
        }


        if (estacionId > 0) {
            cargar().then();
        }
        cargarCatalogos();
    }, []);

    async function cargarCatalogos() {
        const clientes = await apiSource.obtener("clientes");
        setClientes(clientes);

        const subClientes = await apiSource.obtener("subClientesTodos");
        setsubClientes(subClientes);

    }

    const actualizar = (value, propertyName) => {
        dispatch({ type: "update", value: value, name: propertyName });
    };

    // const existeClientesLogisticos = () => {
    //     const clientesLogisticos = clientes?.filter((n) => entity.clientesIds.includes(n.id) && n.esLogistico);
    //     return clientesLogisticos?.length > 0;
    // };
    const obtenerNombreClienteDeSubcliente = (subclienteId) => {
        const sub = subClientes?.find((s) => s.id === subclienteId);
        const cliente = clientes?.find((c) => c.id === sub?.clienteId);
        return cliente?.nombre || "Cliente desconocido";
    };
    
    const formHandler = new FormHandler({
        validationSchema: estacionesValidacionEsquema,
        api,
        dispatch,
    });

    const guardar = async () => {
        if (entity.clientesIds?.some((e) => e === null)) {
            alerts.aviso("Seleccione los clientes correctamente");
            return;
        }

        if (entity.usuariosIds?.some((e) => e === null)) {
            alerts.aviso("Seleccione los usuarios correctamente");
            return;
        }

        if (entity.subClientesIds?.some((e) => e === null)) {
            alerts.aviso("Seleccione los subclientes correctamente");
            return;
        }

        await formHandler.save(entity);

        if (formHandler.valdation.result) {
            onSave();
        }
    };

    function agregarALista(lista, namelist) {
        const nuevo = produce(lista, (draft) => {
            draft.splice(lista.length, 0, null);
        });

        dispatch({ type: "update", value: nuevo, name: namelist });
    }

    function eliminarDeLista(lista, index, namelist) {
        if (namelist === "clientesIds") {
            let subclientesAEliminar = subClientes?.filter((element) => {
                if (element.clienteId === lista[index]) {
                    return element.id;
                }
                return null;
            });

            const subclientes = entity.subClientesIds?.filter(
                (n) => !subclientesAEliminar.some((item) => item.id === n)
            );

            dispatch({ type: "update", value: subclientes, name: "subClientesIds" });
        }

        const nuevo = produce(lista, (draft) => {
            draft.splice(index, 1);
        });

        dispatch({ type: "update", value: nuevo, name: namelist });
    }

    function actualizarLista(lista, index, value, namelist) {
        const nuevo = produce(lista, (draft) => {
            draft[index] = value;
        });

        dispatch({ type: "update", value: nuevo, name: namelist });
    }

    return (
        <>
            <div className="form-container full-height">
                <ReadOnlyProvider defaultReadOnly={soloLectura}>
                    <div className="form-row">
                        <h5 className="col-12">Datos Generales</h5>

                        <FieldTextBox
                            name="nombre"
                            label="Nombre"
                            colMd={10}
                            required
                            maxLength={100}
                            value={entity.nombre}
                            onChange={actualizar}
                            errors={errors}
                        />

                        <div className="form-group col-md-2 check-Activo">
                            <FieldCheckBox name="activo" label="Activo" value={entity.activo} onChange={actualizar} />
                        </div>
                    </div>
               
                    <TabView
                        activeIndex={activeIndex}
                        onTabChange={(e) => setActiveIndex(e?.index)}
                        className="main-tab-view diesel"
                    >
                        <TabPanel header="Clientes">
                            <div className="form-row">
                                <table className="table main-edit-table tableFixHead" align="right">
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col" className="center" style={{ width: "10%" }}>
                                                Cliente
                                            </th>
                                            <th className={"input"} style={{ width: "0%" }}>
                                                <ButtonIcon
                                                    title={"Agregar Clientes"}
                                                    iconName={"SiAddthis"}
                                                    onClick={() => agregarALista(entity.clientesIds, "clientesIds")}
                                                />
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {entity.clientesIds?.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        <FieldDropDown
                                                            name={"estacion"}
                                                            source="clientes"
                                                            fire={true}
                                                            valueById={true}
                                                            required
                                                            value={entity.clientesIds[index]}
                                                            onChange={(value) =>
                                                                actualizarLista(
                                                                    entity.clientesIds,
                                                                    index,
                                                                    value,
                                                                    "clientesIds"
                                                                )
                                                            }
                                                        />
                                                    </td>
                                                    <td>
                                                        <ButtonIcon
                                                            title={"Eliminar"}
                                                            onClick={() =>
                                                                eliminarDeLista(
                                                                    entity.clientesIds,
                                                                    index,
                                                                    "clientesIds"
                                                                )
                                                            }
                                                            iconName={"RiDeleteBinLine"}
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            <div className="form-row">
                                <table className="table main-edit-table tableFixHead" align="right">
                                    <thead className="thead-light">
                                        <tr>
                                            <th scope="col" className="center" style={{ width: "55%" }}>
                                                SubCliente
                                            </th>
                                            <th>Cliente</th>
                                            <th>Estacion</th>
                                           
                                            {/* <th className={"input"} style={{ width: "10%" }}>
                                                <ButtonIcon
                                                    title={"Agregar SubClientes"}
                                                    iconName={"SiAddthis"}
                                                    onClick={() =>
                                                        agregarALista(entity.subClientesIds, "subClientesIds")
                                                    }
                                                />
                                            </th> */}
                                        </tr>
                                    </thead>
                                    <tbody style={{ height: "150px" }}>
                                        {subClientes?.filter((subcliente) =>
                                            entity.clientesIds.includes(subcliente.clienteId) 
                                        ).map((subcliente, index) => {
                                            const isSelected = entity.subClientesIds?.includes(subcliente.id);
                                            return (
                                                <tr key={index}>
                                                    <td className="center">
                                                        {subcliente.nombre}
                                                    </td>
                                                    <td className="center">
                                                        {obtenerNombreClienteDeSubcliente(subcliente.id)}
                                                    </td>
                                                    <td className="center">
                                                    <span className={`tooltip-${entity.id}-${subcliente.id}`}>
                                                            <FieldCheckBox
                                                                colLg={2}
                                                                colMd={3}
                                                                name={`activo-${subcliente.id}`}
                                                                disabled={!!entity.estacion?.find(e => e.subClienteId === subcliente.id)}
                                                                value={isSelected}
                                                                onChange={(checked) => {
                                                                    let updated = [...(entity.subClientesIds || [])];
                                                                    if (checked) {
                                                                    updated.push(subcliente.id);
                                                                    } else {
                                                                    updated = updated.filter((id) => id !== subcliente.id);
                                                                    }
                                                                    dispatch({ type: "update", name: "subClientesIds", value: updated });
                                                                }}
                                                            />
                                                        </span>

                                                        <Tooltip
                                                            target={`.tooltip-${entity.id}-${subcliente.id}`}
                                                            style={{
                                                                maxWidth: "100px",
                                                                fontSize: "10px",
                                                                padding: "1px 3px",
                                                                lineHeight: "1",
                                                            }}
                                                            >
                                                            {entity.estacion?.find(e => e.subClienteId === subcliente.id)?.estacionNombre || "Sin estación"}
                                                            </Tooltip>

                                                    </td>

                                                    <td className="input">
                                                        {isSelected && (
                                                            <ButtonIcon
                                                                title={"Eliminar"}
                                                                onClick={() =>
                                                                    dispatch({
                                                                        type: "update",
                                                                        name: "subClientesIds",
                                                                        value: entity.subClientesIds.filter((id) => id !== subcliente.id),
                                                                    })
                                                                }
                                                                iconName={"RiDeleteBinLine"}
                                                            />
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>



                                </table>
                            </div>
                        </TabPanel>
                       
                
                    </TabView>
                </ReadOnlyProvider>
            </div>
            <div className="form-footer">
                <Button label="Cancelar" className="p-button-outlined" type="button" onClick={close} />

                {!soloLectura && <Button label="Guardar" type="button" onClick={guardar} />}
            </div>
        </>
    );
};

export default DetalleEstaciones;
